/**
 * @generated SignedSource<<999cab2032b5cfefbf5367b8fa927386>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithWrapper_shoppingWith$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithGrid_shoppingWith" | "ShoppingWithHeading_shoppingWith" | "ShoppingWithTopModule_shoppingWith">;
  readonly " $fragmentType": "ShoppingWithWrapper_shoppingWith";
};
export type ShoppingWithWrapper_shoppingWith$key = {
  readonly " $data"?: ShoppingWithWrapper_shoppingWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithWrapper_shoppingWith">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithWrapper_shoppingWith",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithHeading_shoppingWith"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithTopModule_shoppingWith"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithGrid_shoppingWith"
    }
  ],
  "type": "ShoppingWith",
  "abstractKey": null
};

(node as any).hash = "4161980a5a5eb3624da42d8647393d62";

export default node;
